import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=4d4be4aa&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=js&"
export * from "./orderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=4d4be4aa&scoped=true&lang=css&"
import style1 from "./orderStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4be4aa",
  null
  
)

export default component.exports